import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const HadithSection = () => {
  const { language } = useLanguage();
  const sv = language === 'sv';
  return (
    <section className="py-16" style={{ backgroundColor: 'var(--bg-secondary)', borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)' }} data-testid="hadith-section">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <p className="text-2xl md:text-3xl font-serif italic leading-relaxed mb-4" style={{ color: 'var(--text-primary)' }}>
          {sv
            ? '"De bästa bland er är de som lär sig Koranen och lär ut den."'
            : '"The best among you are those who learn the Qur\'an and teach it."'}
        </p>
        <p className="text-sm" style={{ color: 'var(--gold)' }}>
          — {sv ? 'Profeten Muhammad' : 'Prophet Muhammad'} &#xFDFA; (Sahih al-Bukhari)
        </p>
      </div>
    </section>
  );
};

export default HadithSection;
